import { MatDialog } from "@angular/material/dialog";
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChildren, ElementRef, ViewChild } from "@angular/core";
import { BehaviorSubject, Observable, Subject, } from "rxjs";
import { NotificationService } from "src/app/core/services/notification.service";
import { CommonService } from "src/app/core/services/common.service";
import { NotifierService } from "angular-notifier";
import { BaseComponent } from "src/app/shared/components/base/base.component";
import { Location } from '@angular/common';
import { map, startWith } from "rxjs/operators";
import { Message } from "src/app/core/class/message";
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { MenuExportReportService } from "src/app/core/services/menu-export-report.service";
import { TranslateService } from "@ngx-translate/core";
import { DataSource, SelectionModel } from "@angular/cdk/collections";
import { GeneralCategory } from "src/app/shared/models/general-category.model";
import { WarningComponent } from "src/app/shared/components/warning/warning.component";
import { AlertConfigDataHDLDComponent } from "src/app/shared/components/alert-config-data-hdld/alert-config-data-hdld.component";
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { WarningSmsContractService } from '../../../../../../core/services/warning-sms-contract.service';
import { ContractService } from 'src/app/core/services/contract.service';
import { LaborUtilizationReportService } from "src/app/core/services/labor-utilization-report.service";
import { ProcessingService } from 'src/app/core/services/processing.service';
import { takeUntil } from 'rxjs/operators';
import { BlockUIModule } from 'ng-block-ui';
import { BlockUI, NgBlockUI } from "ng-block-ui";
import { DatePipe } from '@angular/common';
import { MatDatepicker } from '@angular/material/datepicker';
import { DateAdapter, MatTableDataSource, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material";
import { AbstractControl, ValidationErrors } from '@angular/forms';
import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
import { NotifyExportDataCustomerComponent } from "src/app/shared/components/notify-export-data-customer-dialog/notify-export-data-customer-dialog.component";
import { ReportDialogComponent } from "../report-dialog/report-dialog.component";
import { pairwise } from 'rxjs/operators'
import { ErrorStateMatcher, ShowOnDirtyErrorStateMatcher } from '@angular/material/core';
export class InstantErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}
const moment = _rollupMoment || _moment;

export function yearValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.trim() === '')) {
    return null;
  }

  let yearNum: number | null = null;
  if (moment.isMoment(value)) {
    if (!value.isValid()) return { invalidYearFormat: true };
    yearNum = value.year();
  }
  else {
    const strVal = String(value).trim();
    if (!/^\d{4}$/.test(strVal)) {
      return { invalidYearFormat: true };
    }
    yearNum = parseInt(strVal, 10);
  }

  // Kiểm tra năm tương lai
  const currentYear = new Date().getFullYear();
  if (yearNum > currentYear) {
    return { futureYear: true };
  }

  return null;
}
@Component({
  selector: 'app-create-report',
  templateUrl: './create-report.component.html',
  styleUrls: ['./create-report.component.scss'],
  providers: [
    { provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher }
  ]
})
export class CreateReportComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  actionForm: FormGroup;
  listDataSource = new MatTableDataSource<any>([]);
  maxDate: Moment = moment();
  matcher = new InstantErrorStateMatcher();
  @ViewChild('yearInput', { static: false }) yearInput!: ElementRef;
  today: Date = new Date();
  isBasicSearchForm: boolean = true;
  isChangeValueForm: boolean = false;
  disabledSave: boolean = false;
  valueSelect: number = 0;
  selection = new SelectionModel<any>(true, []);
  listReportPeriod: any = [
    { labelKey: "menu_export_report.first_half_year", value: 1 },
    { labelKey: "menu_export_report.one_year", value: 2 },
    { labelKey: "menu_export_report.ad_hoc", value: 3 },
  ];
  reportName : string = '';
  reportNo : string = '';
  targetType : number;
  reportDate: any;
  loadingSearch: boolean = false;
  lastTouchedField: string = '';
  dynamicColumns: any[] = [];
  isDetailInit = false;
  displayedColumns: string[] = [
    'select',
    'stt',
    'uuid',
    'contractName',
    'signers',
    'status',
    'authStatus',
    'platformStatus',
    'createdDate',
    'effectiveDate',
    'expiredDate'
  ];
  paginate = {
    currentPage: 0,
    pageSize: 10,
    totalRow: 0,
    totalPage: 0,
    totalPageArray: [],
    no: [],
  };
  dataSelected: Map<any, any> = new Map();
  checkAll: boolean = false;
  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    public commonService: CommonService,
    public message: Message,
    private notifier: NotifierService,
    private router: Router,
    public toast: ToastrService,
    public route: ActivatedRoute,
    public translate: TranslateService,
    private notificationService: NotificationService,
    private activatedRouter: ActivatedRoute,
    private menuExportReportService: MenuExportReportService,
    private contractService: ContractService,
    private warningSmsContractService: WarningSmsContractService,
    private laborUtilizationReportService: LaborUtilizationReportService,
    public processingService: ProcessingService,


  ) {
    super(commonService, message);
    this.notifier = notifier;
  }
  ngAfterViewInit(): void {
    // Xóa câu lệnh throw new Error
  }

  ngOnDestroy(): void {
    // Xóa câu lệnh throw new Error
  }

  ngOnInit(): void {
    this.initForm();
    this.listenReportPeriodChange();

    this.route.paramMap.subscribe((params: any) => {
      const reportId = params.get('id');

      if (reportId) {
        this.loadDetailData(reportId, true);
      } else {
        this.route.queryParams.subscribe((queryParams: any) => {
          if (queryParams && Object.keys(queryParams).length > 0) {
            this.paginate.currentPage = queryParams.page ? Number(queryParams.page) : 0;
            this.paginate.pageSize = queryParams.pageSize ? Number(queryParams.pageSize) : 10;

            this.actionForm.patchValue(queryParams, { emitEvent: false });

            if (this.actionForm.valid) {
              this.loadData();
            }
          }
        });
      }
    });
  }
  private loadDetailData(id: string, isForCopy: boolean= true): void {
    const safeId = encodeURIComponent(id);
  
    this.menuExportReportService.getReportDetail(safeId, isForCopy).subscribe(
      (res: any) => {
        let decodedData = res;
        if (typeof res === 'string') {
          try { 
            decodedData = JSON.parse(res); 
          } catch (e) {
            console.error('Lỗi parse JSON detail:', e);
          }
        }
  
        if (decodedData && (decodedData.code === '200' || decodedData.code === 200 || decodedData.success)) {
          const detail = decodedData.data || decodedData;
          this.isDetailInit = true;
          if (this.dataSelected) this.dataSelected.clear();
          if (this.selection) this.selection.clear();
          this.checkAll = false;
          this.reportName = detail.name; 
          this.reportNo = detail.reportNumber;
          this.targetType = detail.objectTypeCode; 
          this.reportDate = detail.reportDate;
          try {
            const reportType = String(detail.type || detail.reportType || '').toUpperCase();
            const isReportTypeAll = (reportType === 'ALL');
  
            if (!isReportTypeAll) {
              const contracts = detail.laborContracts || detail.contracts || [];
              if (Array.isArray(contracts)) {
                contracts.forEach((item: any) => {
                  const itemId = String(item.id || item.contractId || '');
                  if (itemId && itemId !== 'undefined') {
                    this.dataSelected.set(itemId, Object.assign({}, item, { id: itemId, checked: true }));
                  }
                });
              }
            }
            const parseSafeDate = (val: any) => {
              if (!val) return null;
              const d = new Date(val);
              return isNaN(d.getTime()) ? null : d;
            };
  
            const yearValue = detail.year || detail.reportYear;
            const reportYearMoment = yearValue ? moment(String(yearValue), 'YYYY') : moment();
            
            const periodVal = detail.periodCode !== undefined ? detail.periodCode : (detail.reportPeriod !== undefined && detail.reportPeriod !== null ? detail.reportPeriod : 3);
            const isPeriodCustom = Number(periodVal) === 3;
  
            let finalFromDate = null;
            let finalToDate = null;
            const fromDateCtrl = this.actionForm.get('fromDate');
            const toDateCtrl = this.actionForm.get('toDate');
  
            if (isPeriodCustom) {
              finalFromDate = parseSafeDate(detail.fromDate);
              finalToDate = parseSafeDate(detail.toDate);
  
              if (finalToDate && this.maxDate && finalToDate > this.maxDate) {
                this.maxDate = finalToDate;
              }
  
              if (fromDateCtrl) fromDateCtrl.setValidators([Validators.required]);
              if (toDateCtrl) toDateCtrl.setValidators([Validators.required]);
            } else {
              if (fromDateCtrl) fromDateCtrl.clearValidators();
              if (toDateCtrl) toDateCtrl.clearValidators();
            }
  
            this.actionForm.patchValue({
              reportPeriod: periodVal,
              reportYear: reportYearMoment,
              fromDate: finalFromDate,
              toDate: finalToDate,
              contractSearch: detail.contractSearch || '',
              signerSearch: detail.signerSearch || ''
            }, { emitEvent: false });
            this.handleReportPeriodState(periodVal);
            Object.keys(this.actionForm.controls).forEach(key => {
              const control = this.actionForm.get(key);
              if (control) {
                control.updateValueAndValidity({ emitEvent: false });
              }
            });
          } catch (err) {
            console.error(err);
          } finally {
            this.loadData();
  
            setTimeout(() => {
              this.isDetailInit = false;
            }, 1000);
          }
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }
  conditionSearch: any = {
    reportPeriod: null,
    reportYear: null,
    fromDate: null,
    toDate: null,
    contractSearch: '',
    signerSearch: '',
    page: 0,
    pageSize: 10
  };
  handleReportPeriodState(value: any): void {
    const fromDateCtrl = this.actionForm.get('fromDate');
    const toDateCtrl = this.actionForm.get('toDate');
    const reportYearCtrl = this.actionForm.get('reportYear');

    if (value === 3 || value === '3') {
      if (reportYearCtrl) {
        reportYearCtrl.disable({ emitEvent: false });
        reportYearCtrl.setValue(null, { emitEvent: false });
        reportYearCtrl.clearValidators();
        reportYearCtrl.setErrors(null);
      }

      if (fromDateCtrl && toDateCtrl) {
        fromDateCtrl.setValidators([Validators.required]);
        toDateCtrl.setValidators([Validators.required]);
      }
    } else {
      if (reportYearCtrl) {
        reportYearCtrl.enable({ emitEvent: false });
      }

      if (fromDateCtrl && toDateCtrl) {
        fromDateCtrl.setValue(null, { emitEvent: false });
        toDateCtrl.setValue(null, { emitEvent: false });
        fromDateCtrl.clearValidators();
        toDateCtrl.clearValidators();
        fromDateCtrl.setErrors(null);
        toDateCtrl.setErrors(null);
      }
    }

    if (fromDateCtrl) fromDateCtrl.updateValueAndValidity();
    if (toDateCtrl) toDateCtrl.updateValueAndValidity();
    if (reportYearCtrl) reportYearCtrl.updateValueAndValidity();
  }

  listenReportPeriodChange(): void {
    const reportPeriodCtrl = this.actionForm.get('reportPeriod');
    if (reportPeriodCtrl) {
      this.handleReportPeriodState(reportPeriodCtrl.value);
      reportPeriodCtrl.valueChanges.subscribe((value) => {
        this.handleReportPeriodState(value);
      });
    }
  }
  initForm(): void {
    this.actionForm = this.fb.group({
      reportPeriod: [3, [Validators.required]], 
      reportYear: [null, [yearValidator]],
      fromDate: [null, [Validators.required]], 
      toDate: [null, [Validators.required]],   
      contractSearch: [''],
      signerSearch: ['']
    });
    this.actionForm.valueChanges
      .pipe(
        startWith(this.actionForm.value),
        pairwise()
      )
      .subscribe(([prev, curr]: [any, any]) => {
        const changedKeys = Object.keys(curr).filter(key => curr[key] !== prev[key]);

        const hasOtherFieldsChanged = changedKeys.some(
          key => key !== 'contractSearch' && key !== 'signerSearch'
        );
        if (hasOtherFieldsChanged && !this.isDetailInit) {
          this.clearListData();
        }
      });
  }

  chosenYearHandler(normalizedYear: Moment, datepicker: MatDatepicker<any>): void {
    const yearCtrl = this.actionForm.get('reportYear');

    if (yearCtrl) {
      yearCtrl.setValue(normalizedYear);
      yearCtrl.markAsTouched();
      yearCtrl.markAsDirty();
      yearCtrl.updateValueAndValidity();
    }

    datepicker.close(); 

    if (typeof this.clearListData === 'function') {
      this.clearListData();
    }
  }
  onYearChange(): void {
    const control = this.actionForm.get('reportYear');
    if (control) {
      control.updateValueAndValidity();
    }
  }
  onlyNumber(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }
  // Clear giá trị control trong Form
  clearData(controlName: string): void {
    if (this.actionForm.controls[controlName]) {
      this.actionForm.controls[controlName].setValue(null);
    }
  }

  // 2. Hàm khi bấm nút Check All ở Header
  checkAllCheckBox(): void {
    const currentData = (this.listDataSource && this.listDataSource.data) ? this.listDataSource.data : [];

    currentData.forEach((item: any) => {
      item.checked = this.checkAll;
      if (this.checkAll) {
        this.dataSelected.set(item.id, item);
      } else {
        this.dataSelected.delete(item.id);
      }
    });

    // Re-assign để ép Angular 8 vẽ lại UI cho toàn bộ checkbox dòng
    this.listDataSource.data = [...currentData];
  }

  // 3. Hàm khi tích chọn/bỏ chọn từng dòng
  public onSelect(element: any): void {
    if (element.checked) {
      this.dataSelected.set(element.id, element);
    } else {
      this.dataSelected.delete(element.id);
    }

    this.checkCheckAll();
  }

  // 4. Kiểm tra xem tất cả bản ghi ở trang hiện tại đã được chọn hết chưa
  checkCheckAll(): void {
    const currentData = (this.listDataSource && this.listDataSource.data) ? this.listDataSource.data : [];
    if (currentData.length === 0) {
      this.checkAll = false;
      return;
    }

    this.checkAll = currentData.every((item: any) => this.dataSelected.has(item.id));
  }

  // 5. Đồng bộ lại trạng thái checked mỗi khi nhận dữ liệu từ API / Chuyển trang
  // syncCheckedState(): void {
  //   const currentData = (this.listDataSource && this.listDataSource.data) ? this.listDataSource.data : [];

  //   currentData.forEach((item: any) => {
  //     item.checked = this.dataSelected.has(item.id);
  //   });

  //   this.listDataSource.data = [...currentData];
  //   this.checkCheckAll();
  // }
  syncCheckedState(): void {
    const currentData = (this.listDataSource && this.listDataSource.data) ? this.listDataSource.data : [];

    if (this.selection) {
      this.selection.clear();
    }

    currentData.forEach((item: any) => {
      const keyId = String(item.id || item.contractId || '');
      const isChecked = this.dataSelected ? this.dataSelected.has(keyId) : false;

      item.checked = isChecked;

      if (isChecked && this.selection) {
        this.selection.select(item);
      }
    });

    this.listDataSource.data = [...currentData];
    this.checkCheckAll();
  }

  clearListData(): void {
    this.listDataSource.data = [];
    this.selection.clear();
    this.dataSelected = new Map();
    this.isChangeValueForm = false;

    this.paginate = {
      currentPage: 0,
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: []
    };
  }

  focusOut(fieldName: string): void {
    const control = this.actionForm.get(fieldName);
    if (control && control.value) {
      control.setValue(control.value.trim());
    }
  }
  // Toggle Tìm kiếm nâng cao / cơ bản
  onExpandAdvancedSearchForm(): void {
    this.isBasicSearchForm = false;
  }

  onCloseAdvancedSearchForm(): void {
    this.isBasicSearchForm = true;
    this.actionForm.patchValue({
      contractSearch: '',
      signerSearch: ''
    });
  }

  // --- CALL API LẤY DANH SÁCH ---
  loadData(isResetPage: boolean = true): void {
    console.log('👉 Đã vào được bên trong hàm loadData()');
    if (this.actionForm.invalid) {
      this.actionForm.markAllAsTouched();
      return;
    }

    if (isResetPage) {
      this.paginate.currentPage = 0;
    }

    const formValue = this.actionForm.getRawValue();

    let reportYearValue: any = null;
    if (formValue.reportYear) {
      if (moment.isMoment(formValue.reportYear)) {
        reportYearValue = formValue.reportYear.year();
      } else if (formValue.reportYear instanceof Date) {
        reportYearValue = formValue.reportYear.getFullYear();
      } else {
        reportYearValue = Number(formValue.reportYear); 
      }
    }
    const currentFromDate = formValue.fromDate ? this.formatDateToString(formValue.fromDate) : null;
    const currentToDate = formValue.toDate ? this.formatDateToString(formValue.toDate) : null;

    if (this.conditionSearch && Object.keys(this.conditionSearch).length > 0) {
      const prevPeriod = this.conditionSearch['reportPeriod'] ? String(this.conditionSearch['reportPeriod']) : '';
      const currPeriod = formValue.reportPeriod ? String(formValue.reportPeriod) : '';

      const prevYear = this.conditionSearch['reportYear'] ? String(this.conditionSearch['reportYear']) : '';
      const currYear = reportYearValue ? String(reportYearValue) : '';

      const prevFromDate = this.conditionSearch['fromDate'] || '';
      const currFromDate = currentFromDate || '';

      const prevToDate = this.conditionSearch['toDate'] || '';
      const currToDate = currentToDate || '';

      const isPeriodChanged = prevPeriod !== currPeriod;
      const isYearChanged = prevYear !== currYear;
      const isFromDateChanged = prevFromDate !== currFromDate;
      const isToDateChanged = prevToDate !== currToDate;

      if ((isPeriodChanged || isYearChanged || isFromDateChanged || isToDateChanged) && !this.isDetailInit) {
        this.dataSelected.clear();
        this.checkAll = false;
        if (this.selection) {
          this.selection.clear();
        }
      }
    }
    const rawParams: any = {
      reportPeriod: formValue.reportPeriod,
      reportYear: reportYearValue,
      fromDate: formValue.fromDate ? this.formatDateToString(formValue.fromDate) : null,
      toDate: formValue.toDate ? this.formatDateToString(formValue.toDate) : null,
      contractSearch: formValue.contractSearch ? formValue.contractSearch.trim() : null,
      signerSearch: formValue.signerSearch ? formValue.signerSearch.trim() : null,
      page: this.paginate.currentPage,
      pageSize: this.paginate.pageSize
    };
    this.conditionSearch = {};
    Object.keys(rawParams).forEach(key => {
      const val = rawParams[key];
      if (val !== null && val !== undefined && val !== '') {
        this.conditionSearch[key] = val;
      }
    });
    this.menuExportReportService.getListReportForCreate(this.conditionSearch).subscribe(
      (res: any) => {
        console.log('=== FULL API RESPONSE ===', res);

        let parsedData = res;
        if (typeof res === 'string') {
          try {
            parsedData = JSON.parse(res);
            console.log('=== PARSED RESPONSE ===', parsedData);
          } catch (e) {
            console.error('Lỗi parse JSON:', e);
          }
        }
        const rawRows = (parsedData && parsedData.data && parsedData.data.dataRow)
          || (parsedData && parsedData.dataRow)
          || (parsedData && parsedData.data)
          || [];

        const rows = Array.isArray(rawRows) ? rawRows : [];
        this.listDataSource.data = this.processDataRows(rows);
        const totalCount = (parsedData && parsedData.data && parsedData.data.total)
          || (parsedData && parsedData.data && parsedData.data.totalRow)
          || (parsedData && parsedData.data && parsedData.data.totalElements)
          || (parsedData && parsedData.totalRow)
          || (parsedData && parsedData.total)
          || 0;
        const totalRow = Number(totalCount) || 0;
        const pageSize = this.paginate.pageSize || 10;
        const currentPage = this.paginate.currentPage || 0;
        const totalPage = Math.ceil(totalRow / pageSize);

        this.paginate = {
          currentPage: currentPage,
          pageSize: pageSize,
          totalRow: totalRow,
          totalPage: totalPage,
          totalPageArray: this.commonService.counter(totalPage, 1),
          no: this.commonService.counter(pageSize, currentPage * pageSize + 1)
        };
        this.syncCheckedState();
        console.log('=== PAGINATE OBJECT AFTER UPDATE ===', this.paginate);
      },
      (err: any) => {
        console.error('Lỗi khi tải danh sách:', err);
      }
    );
  }
  processDataRows(rows: any[]): any[] {
    return rows.map((item, index) => {
      return {
        ...item,
        stt: this.paginate.currentPage * this.paginate.pageSize + index + 1,
        idMoha: item.contractUUID || item.idMoha,
        allName: item.contractEnterprises || item.allName,
        statusName: item.Status || item.statusName,
        authStatusName: item.signStatus || item.authStatusName,
        platformStatusName: item.sendMohaStatus || item.platformStatusName,
        createdDate: item.creationTime || item.createdDate,
        effectiveDate: item.effectiveDate
      };
    });
  }
  formatDateToString(dateVal: any): string {
    if (!dateVal) return '';
    const d = new Date(dateVal);
    if (isNaN(d.getTime())) return dateVal;

    const year = d.getFullYear();
    const month = ('0' + (d.getMonth() + 1)).slice(-2);
    const day = ('0' + d.getDate()).slice(-2);

    return `${year}-${month}-${day}`;
  }
  onPageChange(page: number = 0, pageSize: number = 10): void {
    this.paginate.currentPage = page;
    this.paginate.pageSize = pageSize;

    // Truyền false để KHÔNG reset về trang 0
    this.loadData(false);
  }
  async prepareCreateMode() {
    // Khởi tạo các cấu hình phụ (nếu có)
  }

  onBack(): void {

    const hasSelectedItems = this.dataSelected && this.dataSelected.size > 0;

    if (hasSelectedItems) {
      const message = 'Bạn có chắc chắn muốn hủy thao tác tạo mới báo cáo?';
      const confirmDialog = this.dialog.open(WarningComponent, {
        width: '350px',
        data: message
      });
      confirmDialog.afterClosed().subscribe((ref: any) => {
        if (ref) {
          this.navigateToReportList();
        }
      });
    } else {
      // TH người dùng chưa thao tác -> Quay trở lại màn danh sách ngay
      this.navigateToReportList();
    }
  }

  /** Chuyển hướng về màn danh sách báo cáo */
  private navigateToReportList(): void {
    this.router.navigate(['/home-enterprise/menu-export-report']);
  }

  /** Nút 2: Xuất toàn bộ bản ghi */
  exportAll(): void {
    this.openReportGeneralInfoModal(true);
  }

  /** Nút 3: Xuất bản ghi đã chọn */
  exportSelected(): void {
    this.openReportGeneralInfoModal(false);
  }

  /** Hàm dùng chung để mở Popup thông tin chung báo cáo */
  private openReportGeneralInfoModal(isExportAll: boolean): void {
    // Validate Form tìm kiếm trước khi lấy dữ liệu
    if (this.actionForm.invalid) {
      this.actionForm.markAllAsTouched();
      return;
    }

    if (isExportAll) {
      // 1. TRƯỜNG HỢP XUẤT TOÀN BỘ: Lấy params lọc từ Form nhưng BỎ phân trang
      const formValue = this.actionForm.getRawValue();

      let reportYearValue: any = null;
      if (formValue.reportYear) {
        if (moment.isMoment(formValue.reportYear)) {
          reportYearValue = formValue.reportYear.year();
        } else if (formValue.reportYear instanceof Date) {
          reportYearValue = formValue.reportYear.getFullYear();
        } else {
          reportYearValue = Number(formValue.reportYear);
        }
      }

      const rawParams: any = {
        reportPeriod: formValue.reportPeriod,
        reportYear: reportYearValue,
        fromDate: formValue.fromDate ? this.formatDateToString(formValue.fromDate) : null,
        toDate: formValue.toDate ? this.formatDateToString(formValue.toDate) : null,
        contractSearch: formValue.contractSearch ? formValue.contractSearch.trim() : null,
        signerSearch: formValue.signerSearch ? formValue.signerSearch.trim() : null,
        selectionMode: isExportAll ? "ALL" : "SELECTED"
        // Bỏ 'page' và 'pageSize' tại đây để lấy ALL
      };

      const exportParams: any = {};
      Object.keys(rawParams).forEach(key => {
        const val = rawParams[key];
        if (val !== null && val !== undefined && val !== '') {
          exportParams[key] = val;
        }
      });

      // Gọi API lấy toàn bộ bản ghi
      this.menuExportReportService.getListReportForCreate(exportParams).subscribe({
        next: (res: any) => {
          let parsedData = res;
          if (typeof res === 'string') {
            try { parsedData = JSON.parse(res); } catch (e) { console.error('Lỗi parse JSON:', e); }
          }

          const rawRows = (parsedData && parsedData.data && parsedData.data.dataRow)
            || (parsedData && parsedData.dataRow)
            || (parsedData && parsedData.data)
            || [];

          const rows = Array.isArray(rawRows) ? rawRows : [];
          const exportItems = this.processDataRows(rows); // Format dữ liệu đầy đủ 18 bản ghi

          // Mở Dialog với danh sách đầy đủ
          this.showDialog(isExportAll, exportItems);
        },
        error: (err) => {
          console.error('Lỗi khi tải danh sách xuất báo cáo:', err);
        }
      });

    } else {
      // 2. TRƯỜNG HỢP XUẤT BẢN GHI ĐÃ CHỌN: Lấy danh sách client đã tích chọn
      const exportItems = Array.from(this.dataSelected.values());
      this.showDialog(isExportAll, exportItems);
    }
  }

  private showDialog(isExportAll: boolean, exportItems: any[]): void {
    const formValues = this.actionForm ? this.actionForm.value : {};

    // 1. Kiểm tra mảng exportItems hoặc dataSource của bảng
    const dataSourceData = (this.listDataSource && this.listDataSource.data) ? this.listDataSource.data : [];
    const items = (exportItems && exportItems.length > 0) ? exportItems : dataSourceData;

    // 2. Tìm phần tử đầu tiên có chứa certificateNo
    const itemWithCert = items.find((item: any) => item && item.certificateNo);

    const certificateNo = (itemWithCert && itemWithCert.certificateNo) ? itemWithCert.certificateNo : '';
    const currentTaxCode = certificateNo || localStorage.getItem('taxCode') || '';
    const period = formValues.reportPeriod || null;
    const year = formValues.reportYear || null;
    const fromDate = formValues.fromDate || null;
    const toDate = formValues.toDate || null;

    const dialogRef = this.dialog.open(ReportDialogComponent, {
      width: '65%',
      maxHeight: '90vh',
      disableClose: true,
      data: {
        isExportAll: isExportAll,
        selectionMode: isExportAll ? "ALL" : "SELECTED",
        selectedData: items,
        taxCode: currentTaxCode,
        reportPeriod: period,
        reportYear: year,
        fromDate: fromDate,
        toDate: toDate,
        reportName: this.reportName,
        reportNo: this.reportNo,
        targetType: this.targetType,
        reportDate: this.reportDate
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result && result.action === 'SUBMIT') {
        const payload = {
          ...result.formValue,
          isExportAll: isExportAll,
          contractIds: isExportAll ? [] : exportItems.map((item: any) => item.id)
        };
      }
    });
  }
  displayTooltip(text: string, index: number, colName: string): string {
    return text || '';
  }
  formatDateString(value: string): string {
    if (!value) return '';
    const cleanValue = value.replace(/\D/g, '');
    if (cleanValue.length === 8) {
      const day = cleanValue.substring(0, 2);
      const month = cleanValue.substring(2, 4);
      const year = cleanValue.substring(4, 8);
      return `${day}/${month}/${year}`;
    }
    return value.trim();
  }

  onDateInputChange(fieldName: string, inputElem: HTMLInputElement, control: AbstractControl) {
    this.lastTouchedField = fieldName;

    const formattedValue = this.formatDateString(inputElem.value);
    inputElem.value = formattedValue;

    const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;

    if (formattedValue && regex.test(formattedValue)) {
      const [day, month, year] = formattedValue.split('/').map(Number);
      const dateObj = new Date(year, month - 1, day);

      if (dateObj.getFullYear() === year && dateObj.getMonth() === month - 1 && dateObj.getDate() === day) {
        control.setValue(dateObj);
      } else {
        control.setValue(null);
      }
    } else {
      control.setValue(null);
    }

    // Trigger lại validation (Thay cho ?.updateValueAndValidity)
    const fromCtrl = this.actionForm.get('fromDate');
    const toCtrl = this.actionForm.get('toDate');

    if (fromCtrl) {
      fromCtrl.updateValueAndValidity({ emitEvent: false });
    }
    if (toCtrl) {
      toCtrl.updateValueAndValidity({ emitEvent: false });
    }
  }

  // 4. Validator kiểm tra Từ ngày <= Đến ngày (FormGroup level)
  dateRangeValidator(group: FormGroup) {
    const fromCtrl = group.controls['fromDate'];
    const toCtrl = group.controls['toDate'];

    if (!fromCtrl || !toCtrl || !fromCtrl.value || !toCtrl.value) {
      return null;
    }

    const fromDate = new Date(fromCtrl.value);
    const toDate = new Date(toCtrl.value);

    if (fromDate > toDate) {
      if (this.lastTouchedField === 'toDate') {
        toCtrl.setErrors({ ...toCtrl.errors, dateRangeInvalid: true });
        this.clearControlError(fromCtrl, 'dateRangeInvalid');
      } else {
        fromCtrl.setErrors({ ...fromCtrl.errors, dateRangeInvalid: true });
        this.clearControlError(toCtrl, 'dateRangeInvalid');
      }
    } else {
      this.clearControlError(fromCtrl, 'dateRangeInvalid');
      this.clearControlError(toCtrl, 'dateRangeInvalid');
    }
    return null;
  }

  // Hàm hỗ trợ xóa lỗi cụ thể trên Control
  clearControlError(control: AbstractControl, errorName: string) {
    if (control && control.hasError(errorName)) {
      delete control.errors[errorName];
      if (!Object.keys(control.errors).length) {
        control.setErrors(null);
      }
    }
  }

  getErrorMessageV2(pickerInput: string, isExpired: boolean = false, nameField: string): string {
    const control = this.actionForm.get(nameField);

    // A. Kiểm tra BỎ TRỐNG
    if (!pickerInput || pickerInput.trim() === '') {
      const fieldKey = nameField === 'fromDate' ? 'menu_export_report.data_from_date' : 'menu_export_report.data_to_date';
      const fieldLabel = this.message.getMessage(fieldKey);
      return this.message.getMessage('menu_export_report.validation.required').replace('{0}', fieldLabel);
    }

    // B. Kiểm tra ĐỊNH DẠNG DD/MM/YYYY
    const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
    if (!regex.test(pickerInput)) {
      return this.message.getMessage('validation.format_of_date');
    }

    const [day, month, year] = pickerInput.split('/').map(Number);
    const date = new Date(year, month - 1, day);
    const isValid = date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;

    if (!isValid) {
      return this.message.getMessage('validation.format_of_date');
    }

    // C. Kiểm tra NGÀY TƯƠNG LAI
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (date > today) {
      const fieldLabel = nameField === 'fromDate'
        ? this.message.getMessage('menu_export_report.data_from_date')
        : this.message.getMessage('menu_export_report.data_to_date');
      return this.message.getMessage('validation.future_date_not_allowed').replace('{0}', fieldLabel);
    }

    // 4. SO SÁNH TỪ NGÀY > ĐẾN NGÀY
    const fromCtrl = this.actionForm.get('fromDate');
    const toCtrl = this.actionForm.get('toDate');

    const fromVal = fromCtrl ? fromCtrl.value : null;
    const toVal = toCtrl ? toCtrl.value : null;

    if (fromVal && toVal) {
      const fromDate = new Date(fromVal);
      const toDate = new Date(toVal);
      fromDate.setHours(0, 0, 0, 0);
      toDate.setHours(0, 0, 0, 0);

      if (fromDate > toDate) {
        // Chỉ báo lỗi ở ô vừa thao tác sau cùng (lastTouchedField)
        if (this.lastTouchedField === 'fromDate') {
          if (fromCtrl) fromCtrl.setErrors({ dateRangeInvalid: true });
          if (toCtrl) this.clearControlError(toCtrl, 'dateRangeInvalid');

          if (nameField === 'fromDate') {
            return this.message.getMessage('menu_export_report.validation.from_date_greater_than_to_date');
          }
        } else if (this.lastTouchedField === 'toDate') {
          if (toCtrl) toCtrl.setErrors({ dateRangeInvalid: true });
          if (fromCtrl) this.clearControlError(fromCtrl, 'dateRangeInvalid');

          if (nameField === 'toDate') {
            return this.message.getMessage('menu_export_report.validation.to_date_greater_than_from_date');
          }
        }
      } else {
        // Nếu ngày hợp lệ thì xóa lỗi cả 2 ô
        if (fromCtrl) this.clearControlError(fromCtrl, 'dateRangeInvalid');
        if (toCtrl) this.clearControlError(toCtrl, 'dateRangeInvalid');
      }
    }

    return '';
  }
}
